module.exports = __webpack_public_path__ + "static/media/SM-ST2-TRIAL-if-wrong.9e73b886.mp3";